class BenefitPoint extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-benefitpoint-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
                600: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                900: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                }
            },
            navigation: {
                nextEl: '[data-benefitpoint-next]',
                prevEl: '[data-benefitpoint-prev]',
            },
        });
    }
}
